import React from 'react'
import styles from './dialog.module.css'

const Dialog = ({ children }) => {
  return <div className={styles.container}>{children}</div>
}

export default Dialog
